module.exports = __webpack_public_path__ + "img/ian.f29fffe0.jpg";